import { render, staticRenderFns } from "./OnboardingProfiles.vue?vue&type=template&id=54eb297b&scoped=true"
import script from "./OnboardingProfiles.vue?vue&type=script&lang=js"
export * from "./OnboardingProfiles.vue?vue&type=script&lang=js"
import style0 from "./OnboardingProfiles.vue?vue&type=style&index=0&id=54eb297b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb297b",
  null
  
)

export default component.exports